import { Button, Stack } from "@mui/material";
import React from "react";

function FunctionButtons({ handleCloseModal, error, computeTTest }) {
  return (
    <Stack>
      {error && (
        <p style={{ color: "red", marginBottom: 20, textAlign: "right" }}>
          {error}
        </p>
      )}
      <Stack direction="row" spacing={1} sx={{ ml: "auto" }}>
        <Button
          variant="outlined"
          style={{
            borderRadius: "7px",
            marginTop: "auto",
          }}
          onClick={handleCloseModal}
        >
          Cancel
        </Button>

        <Stack>
          <Button
            variant="contained"
            style={{
              width: "auto",
              borderRadius: "7px",
            }}
            onClick={() => computeTTest()}
          >
            Run Function
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default FunctionButtons;
